import axios from 'axios';

// Create axios instance with default config
const axiosInstance = axios.create({
  withCredentials: true
});

// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.response?.data?.error_message === 'Unauthorized') {
      // Redirect to signin page
      if(window.location.pathname !== '/signin') {
        window.location.href = '/signin';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 